module.exports = __webpack_public_path__ + "static/media/README.473558f4.md";